/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_System_Logo_AltInputs */



/**
* | output |
* | --- |
* | "System Logo File" |
*
* @param {Iframe_Remote_System_Logo_AltInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_system_logo_alt = /** @type {((inputs?: Iframe_Remote_System_Logo_AltInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_System_Logo_AltInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fichier de logo systeme")
	if (locale === "de") return /** @type {LocalizedString} */ ("Systemlogo-Datei")
	if (locale === "it") return /** @type {LocalizedString} */ ("File del logo di sistema")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Файл логотипа системы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Archivo del logotipo del sistema")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("系统徽标文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("システムロゴファイル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सिस्टम लोगो फ़ाइल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Arquivo de logotipo do sistema")
	return /** @type {LocalizedString} */ ("System Logo File")
});